import React from 'react';
import TopNavBar from '../common/Header/TopNavBar';
import Footer from '../common/Footer/Footer';
import BannerSlide from '../Sections/BannerSlides';
import pers1 from '../images/pers1.jpg';
import pers2 from '../images/pers2.jpg';
import pers3 from '../images/pers3.jpg';

function AboutPage() {
  return (
    <div>
      <TopNavBar />
      <BannerSlide />

      <section className="about-section">
        <div className="container about-con py-5">
          {/* <h3 className="text-center">About Page</h3> */}
          <div className="row rowh">
            <div className="col-md-6 offset-md-3">
              <header className="head text-white text-center py-5">
                <h2>Welcome to Our Software House</h2>
                <p>We create innovative software solutions.</p>
              </header>
            </div>
          </div>

          {/* Team Section */}
          <div className="row my-5">
            {/* Team Member 1 */}
            <div className="col-md-4">
              <div className="card team-member-card">
                <img src={pers1} className="card-img-top" alt="Team Member 1" />
                <div className="card-body">
                  <h5 className="card-title">John Doe</h5>
                  <p className="card-text">Software Developer</p>
                </div>
              </div>
            </div>

            {/* Team Member 2 */}
            <div className="col-md-4">
              <div className="card team-member-card">
                <img src={pers2} className="card-img-top" alt="Team Member 2" />
                <div className="card-body">
                  <h5 className="card-title">Jane Smith</h5>
                  <p className="card-text">UI/UX Designer</p>
                </div>
              </div>
            </div>

            {/* Team Member 3 */}
            <div className="col-md-4">
              <div className="card team-member-card">
                <img src={pers3} className="card-img-top" alt="Team Member 3" />
                <div className="card-body">
                  <h5 className="card-title">David Johnson</h5>
                  <p className="card-text">Project Manager</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="row ">
            <div className="col p-3 ">
              <h2 className="text-center">Contact Us</h2>
              <p>If you have any questions or inquiries, please feel free to contact us.</p>
              <p>Email: contact@softwarehouse.com</p>
              <p>Phone: +1 (123) 456-7890</p>
            </div>
            <div className="col bg-secondary p-5 rounded">
              <h2 className="text-center">Send us a Message</h2>
              <form>
                <div className="form-group">
                  <label htmlFor="name">Name:</label>
                  <input type="text" className="form-control" id="name" placeholder="Your Name" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email:</label>
                  <input type="email" className="form-control" id="email" placeholder="Your Email" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message:</label>
                  <textarea className="form-control" id="message" rows="4" placeholder="Your Message"></textarea>
                </div>
                <button type="submit" className="btn btn-primary">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutPage;
